import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: Article → /blog
export const Route = createFileRoute("/article")({
  beforeLoad: () => {
    throw redirect({ to: "/blog", replace: true });
  },
  component: () => null,
});
